import { ChainProjectsSidebar } from 'modules/chains/components/ChainProjectsSidebar';
import { selectPrivateBlockchainCountByChainID } from 'modules/stats/store/private/selectors';
import { useAppSelector } from 'store/useAppSelector';
import { useChainsPrivateStatsParams } from 'modules/chains/components/ChainsPrivateStatsProvider';
import { useDialog } from 'modules/common/hooks/useDialog';

import { BaseChainsCard } from '../../../BaseChainsCard';
import { IChainCardProps } from '../../../PublicChains/components/PublicChainCard';
import {
  IUsePrivateChainCardProps,
  usePrivateChainCard,
} from './hooks/usePrivateChainCard';
import { PrivateChainCardActions } from './components/PrivateChainCardActions';
import { EChainView } from '../../../ChainViewSelector';

export interface PrivateChainCardProps
  extends Omit<IChainCardProps, 'onOpenUpgradeModal'>,
    IUsePrivateChainCardProps {
  projectsLoading: boolean;
}

export const PrivateChainCard = ({
  chain,
  hasPremium,
  projects,
  projectsLoading,
  projectsWithBlockchains,
  timeframe,
  view = EChainView.Cards,
}: PrivateChainCardProps) => {
  const privateStatsParams = useChainsPrivateStatsParams();

  const totalRequests = useAppSelector(state =>
    selectPrivateBlockchainCountByChainID(state, privateStatsParams, chain.id),
  );

  const totalRequestsStr = totalRequests.toString();

  const {
    isOpened: isOpenedAddToProjectsSidebar,
    onClose: onCloseAddToProjectsSidebar,
    onOpen: onOpenAddToProjectsDialog,
  } = useDialog();

  const {
    anchorEl,
    chainProjects,
    filteredJwtTokens,
    handleClose,
    handleOpenChainMenu,
    hasChainProjects,
    isEndpointLocked,
    isMenuOpened,
  } = usePrivateChainCard({
    chain,
    hasPremium,
    projects,
    projectsWithBlockchains,
  });

  const isChainProjectsEmpty = !hasChainProjects && !projectsLoading;

  return (
    <>
      <BaseChainsCard
        view={view}
        chain={chain}
        totalRequests={totalRequestsStr}
        shouldShowDashInsteadOfRequestsString={
          totalRequests === 0 && isChainProjectsEmpty
        }
        isRequestsDisabled={isChainProjectsEmpty}
        timeframe={timeframe}
        actions={
          <PrivateChainCardActions
            anchorEl={anchorEl}
            chain={chain}
            chainProjects={chainProjects}
            filteredJwtTokens={filteredJwtTokens}
            handleClose={handleClose}
            handleOpenChainMenu={handleOpenChainMenu}
            isCardView={view === EChainView.Cards}
            isChainProjectsEmpty={isChainProjectsEmpty}
            isEndpointLocked={isEndpointLocked}
            onOpenAddToProjectsDialog={onOpenAddToProjectsDialog}
            open={isMenuOpened}
            projectsLoading={projectsLoading}
          />
        }
      />
      <ChainProjectsSidebar
        chain={chain}
        isOpenedAddToProjectsSidebar={isOpenedAddToProjectsSidebar}
        projects={projects}
        onCloseAddToProjectsSidebar={onCloseAddToProjectsSidebar}
        projectsWithBlockchains={projectsWithBlockchains}
      />
    </>
  );
};
